define((require) => {
    "use strict";

    const AnimationController = require("shared/ui/experience/widgets/animations/AnimationController");

    /**
     * The animation controller for fade.
     *
     * @class FadeAnimationController
     * @constructor
     */
    return AnimationController.extend({

        /**
         * @inheritDoc
         */
        type: AnimationController.Type.INTRO, // We're fading from 0 to 1.0, hence "intro"

        descriptor() {
            // Describe the animation - fade from 0 to target opacity...
            return {
                fromTo: [{opacity: 0}, {opacity: this.widgetModel.get("opacity") || 1.0}]
            };
        }
    });
});



// WEBPACK FOOTER //
// ./src/shared/ui/experience/widgets/animations/fade/FadeAnimationController.js